<template>
  <div class="navigation">
    <CiButton
      class="navigation__button"
      :class="ciClassesSecondary"
      :disabled="ciDisabledSecondary"
      @click="secondaryClicked"
      v-if="ciActiveSecondary"
    >
      <slot name="secondary"></slot>
    </CiButton>
    <CiButton
      class="navigation__button"
      :class="ciClassesPrimary"
      :disabled="ciDisabledPrimary"
      @click="primaryClicked"
      v-if="ciActivePrimary"
    >
      <slot name="primary"></slot>
    </CiButton>
  </div>
</template>
<script>
import { CiButton } from '@/components/index'

export default {
  name: 'CiGenericNavigation',
  components: { CiButton },
  props: {
    ciClassesPrimary: {
      type: String,
      default: 'button--primary',
    },
    ciClassesSecondary: {
      type: String,
      default: 'button--secondary',
    },
    ciActivePrimary: {
      type: Boolean,
      default: true,
    },
    ciActiveSecondary: {
      type: Boolean,
      default: true,
    },
    ciDisabledPrimary: {
      type: Boolean,
      required: false,
      default: false,
    },
    ciDisabledSecondary: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {},
  methods: {
    secondaryClicked() {
      this.$emit('clickSecondary')
    },

    primaryClicked() {
      this.$emit('clickPrimary')
    },
  },
}
</script>
<style lang="scss" scoped>
.navigation {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px 0;

  @include media-breakpoint-up(md) {
    flex-direction: row;
    margin: 20px 0;
  }
}

.navigation__button {
  width: 100%;

  @include media-breakpoint-up(md) {
    width: auto;
  }
}

.button--secondary {
  order: 2;

  @include media-breakpoint-up(md) {
    order: 1;
  }
}

.button--primary {
  order: 1;

  @include media-breakpoint-up(md) {
    order: 2;
  }

  &:last-child {
    margin-left: auto;
  }
}

.button--center {
  &:last-child {
    margin: 0 auto;
  }
}
</style>
